var Formatter = require('formatter');
var HashDialogView = require('hashdialogview');
var JoinDefaultServersMixins = require('joindefaultserversmixins');
var Org = require('org');
var OrgDetailView = require('orgdetailview');


var OrgsDialogView = HashDialogView.extend($.extend({}, JoinDefaultServersMixins, {
    el: '#orgsOverlayContents',
    wrapper: $('#orgsContainer'),
    initialize: function (options) {
        JoinDefaultServersMixins.initialize.call(this, options);
        HashDialogView.prototype.initialize.call(this, options);
        
        this.loading = $('#orgLoading');

        this.orgCurrentUpgrade = $('.orgCurrentUpgrade');

        this.benefits = $('#orgBenefits');

        this.joinScreen = $('#orgJoinScreen');
        this.joinDefaultChanBenefit = $('.orgJoinDefaultChanBenefit');

        this.progression = $('#orgProgression');
        this.progressionSteps = this.progression.find('span.progress');
        this.progressionStart = $('#orgProgressionStart');
        this.progressionConnections = $('#orgProgressionConnections');
        this.progressionMembers = $('#orgProgressionMembers');
        this.progressionPay = $('#orgProgressionPay');

        this.createLoading = $('#orgCreateLoading');
        this.createName = $('#orgCreateName');
        this.createBilling = $('#orgCreateBilling');
        this.createForm = $('form#orgCreateForm');
        this.createPrice = $('#orgCreatePrice');
        this.createError = $('#orgCreateError');
        this.createDisabled = true;

        this.createScreen = $('#orgCreateScreen');
        this.createYours = $('#orgCreateYours');
        this.createYoursPlural = $('#orgCreateYoursPlural');
        this.seatPrice = $('#orgSeatPrice');

        this.listScreen = $('#orgListScreen');

        this.formatter = new Formatter();
        this.detail = new OrgDetailView({
            session: this.model,
            dialog: this
        });

        this.list = $('ul#orgList');

        this.model.bind('change:email', this.renderEmail, this);
        this.model.bind('plansChange', this.renderPlan, this);

        _.bindAll(this, 'show', 'showBilling', '_doShow', 'showError');
        
        this.model.bind('init', this.init, this);

        this.model.bind('stat orgsChange', this.renderOrgs, this);
    },
    events: $.extend({}, HashDialogView.prototype.events, JoinDefaultServersMixins.events, {
        'submit #orgCreateForm': 'submitCreateForm'
    }),
    init: function () {
        if (!this.initialized) {
            this.router.route('?/teams=on', 'show', this.show);
            this.router.route('?/team-error=:error', 'showError', this.showError);
            this.router.route('?/teams', 'show', this.show);
            this.router.route('?/team=:orgId', 'show', this.show);
            this.router.route('?/team-billing=:orgId', 'showBilling', this.showBilling);
            this.initialized = true;
        }
    },
    renderOrgs: function () {
        this.orgCurrentUpgrade.toggle(this.model.hasActiveSubscription());
        this.orgCurrentUpgrade.toggleClass('active', this.model.hasActiveOrgs());
        // Run show again for current org
        if (this.detail.isVisible()) {
            this._doShow(this.model.orgs.get(this.detail.model.id), this.detail.isBillingShown());
        }
        this.list.empty();
        var count = this.model.orgs.length;
        this.createYours.toggle(!!count);
        this.createYoursPlural.toggle(count != 1);
        this.model.orgs.each(function (org) {
            var li = $('<li>').append($('<a>').attr('href', '/?/team=' + org.id).text(org.get('name')));
            this.list.append(li);
        }, this);
        // Org was just created, show it
        if (this.orgToShow) {
            this.showOrg(this.model.orgs.get(this.orgToShow));
            this.orgToShow = null;
        }
    },
    showCreate: function () {
        this.showStartProgression();

        this.loading.hide();
        this.joinScreen.hide();
        this.listScreen.hide();
        this.detail.hide();
        this.benefits.show();

        this.createScreen.show();
    },
    showStartProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('active');
        this.progression.addClass('show');
    },
    showConnectionsProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('complete');
        this.progressionConnections.addClass('active');
        this.progression.addClass('show');
    },
    showMembersProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('complete');
        this.progressionConnections.addClass('complete');
        this.progressionMembers.addClass('active');
        this.progression.addClass('show');
    },
    showPaymentProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('complete');
        this.progressionConnections.addClass('complete');
        this.progressionMembers.addClass('complete');
        this.progressionPay.addClass('active');
        this.progression.addClass('show');

    },
    hideProgression: function () {
        this.progression.removeClass('show');
    },
    showOrgOnCreate: function (orgId) {
        this.orgToShow = orgId;
    },
    showOrg: function (org, billing) {
        if (!org.isAdmin()) {
            billing = false;
        }
        var url = billing ? 'team-billing' : 'team';
        this.router.navigate('?/' + url + '=' + org.id, {replace: true});

        this.hideProgression();
        this.loading.hide();
        this.joinScreen.hide();
        this.createScreen.hide();
        this.listScreen.hide();
        this.benefits.hide();

        this.detail.show(org, billing);
    },
    showList: function () {
        this.hideProgression();

        this.loading.hide();
        this.joinScreen.hide();
        this.createScreen.hide();
        this.detail.hide();
        this.benefits.hide();

        this.listScreen.show();
    },
    _doShow: function (orgId, billing) {
        if (orgId !== 'new' && this.model.orgs.length) {
            var org = this.model.orgs.get(orgId);
            if (org) {
                return this.showOrg(org, billing);
            } else if (this.model.hasOneOrg()) {
                return this.showOrg(this.model.orgs.first());
            } else {
                this.showList();
                this.router.navigate('?/teams', {replace: true});
            }
        } else {
            this.showCreate();
            this.router.navigate('?/team=new', {replace: true});
        }
    },
    showError: function (error) {
        this.hideProgression();
        this.loading.hide();

        this.listScreen.hide();
        this.detail.hide();
        this.createScreen.hide();
        this.benefits.hide();

        this.showJoinError({message: error});

        this.joinScreen.fadeIn('fast');

        HashDialogView.prototype.show.call(this);
    },
    showJoin: function (inviteKey, name) {
        if (this.joining) {
            return;
        }
        this.joining = true;
        this.showJoinInit(name);
        $('#orgJoinInvite').val(inviteKey);

        this.model.getOrgInviteConnections(inviteKey, _.bind(function (response) {
            this.loading.hide();
            if (response.error || response.success === false) {
                this.showJoinError(response);
            } else {
                var org = new Org(response, {session: this.model});
                this.showJoinOrg(org);
                if (org.hasConnections() || org.hasIrcd()) {
                    this.joinDefaultChanBenefit.show();
                } else {
                    this.joinDefaultChanBenefit.hide();
                }
            }
            this._doShowJoin();
        }, this));
    },
    joinDefaultServerAction: function (data, callback) {
        this.model.joinOrg(data, callback);
    },
    joinDefaultServerEndAction: function () {
        this.hide();
    },
    _doShowJoin: function () {
        this.benefits.hide();
        this.joinScreen.fadeIn('fast');

        this.joining = false;

        HashDialogView.prototype.show.call(this);
    },
    showBilling: function (orgId) {
        this.show(orgId, true);
    },
    show: function (orgId, billing) {
        this.hideCreateError();
        this._doShow(orgId, billing);
        HashDialogView.prototype.show.call(this);
    },
    getPerSeat: function () {
        return (this.model.plans && this.model.plans.org) ? this.model.plans.org.per_seat : 400;
    },
    renderPlan: function () {
        this.seatPrice.text(this.formatter.amount(this.model.getCurrency(), this.getPerSeat()));
        this.enableCreateForm();
        this.createLoading.hide();
        this.createPrice.show();
    },
    isCreateDisabled: function () {
        return this.createDisabled;
    },
    disableCreateForm: function () {
        if (!this.isCreateDisabled()) {
            this.createDisabled = true;
            this.createForm.find('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableCreateForm: function () {
        if (this.isCreateDisabled()) {
            this.createDisabled = false;
            this.createForm.find('input, button, textarea').prop('disabled', false);
        }
    },
    submitCreateForm: function (e) {
        e.preventDefault();
        if (this.isCreateDisabled()) {
            return;
        }

        var data = this.createForm.serializeForm();

        if (!data.name) {
            this.showCreateError('missing_name');
            return;
        }
        if (!data.billing_email) {
            this.showCreateError('missing_billing_email');
            return;
        }

        this.disableCreateForm();
        this.hideCreateError();

        this.model.createOrg(data, _.bind(function (response) {
            this.enableCreateForm();
            if (response.success) {
                this.createName.val('');
                this.showOrgOnCreate(response.org.id);
            } else {
                this.showCreateError(response.message);
            }
        }, this));
    },
    showCreateError: function (message) {
        var msg = "";
        switch (message) {
        case "missing_plan":
            msg = "Missing plan";
            break;
        case "missing_stripe_token":
            msg = "Missing payment";
            break;
        case "missing_name":
            msg = "Missing team name";
            break;
        case "missing_billing_email":
            msg = "Missing billing email";
            break;
        case 'invalid_billing_email':
            msg = 'Invalid billing email';
            break;
        case 'server_error':
            msg = 'There was a problem creating this team';
            break;
        default:
            msg = 'There was a problem creating this team: ' + message;
            break;
        }
        this.createError.text(msg).fadeIn('fast');
    },
    hideCreateError: function () {
        this.createError.hide();
    },
    renderEmail: function () {
        var currentVal = this.createBilling.val();
        if (!currentVal || this.model.previous('email') == currentVal) {
            this.createBilling.val(this.model.get('email'));
        }
    },
    focusCreateName: function () {
        this.createName.focus().select();
    }
}));


module.exports = OrgsDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/orgsdialogview.js
// module id = egpX
// module chunks = 1